import React from 'react';
import useFitText from 'use-fit-text';
import { css } from 'styled-components/macro';

const containercss = css`
  display: flex;
  overflow: hidden;
  position: absolute;
  border-style: none;
  box-sizing: border-box;
  align-items: flex-start;

  > span {
    width: 100%;
    padding: 15px;
  }
`;

export function TreeemapNode(props: any) {
  const { fontSize, ref } = useFitText({ logLevel: 'none' });
  return (
    <div
      ref={ref}
      {...props.handlers}
      style={{
        ...props.style,
        fontSize,
        color: '#2E4063',
        top: props.style.y,
        left: props.style.x,
        background: props.style.color,
        cursor: props.node.data.orgs ? 'pointer' : 'default',
        border: '0.5px solid #2E4063',
      }}
      css={containercss}
    >
      {(props.style.width > 99 || props.style.height > 99) && (
        <span>{props.node.data.name}</span>
      )}
    </div>
  );
}
